import { Dialog, DialogPanel } from '@headlessui/react'

import XIcon from '@Icons/x-close-filter.svg?react'
import SpinLoader from '@Utils/loaders/spin'

interface CancelImportModalProps {
  onModalClose: () => void
  onModalConfirm: () => void
  isCancelImportLoading: boolean
  cancelClicked?: boolean
}

function CancelImportModal({
  onModalClose,
  onModalConfirm,
  isCancelImportLoading,
  cancelClicked,
}: CancelImportModalProps): JSX.Element {
  return (
    <Dialog
      open={!!cancelClicked}
      onClose={onModalClose}
      className="relative z-50"
    >
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{
          background: 'rgba(41, 41, 41, 0.7)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <DialogPanel className="relative border rounded-xl shadow-xl bg-white-100">
          <div className="flex flex-col p-6 gap-y-6 items-center">
            <h1 className="font-medium text-lg text-gray-900 flex w-full items-center justify-between">
              Please Confirm
              <button
                className="active:bg-gray-50 border-0"
                onClick={onModalClose}
              >
                <XIcon />
              </button>
            </h1>
            <p className="font-normal text-gray-500">
              Are you sure cancelling the batch import?
            </p>
            <div className="flex flex-row w-full">
              <button
                onClick={onModalClose}
                className="border border-solid border-gray-300 shadow-sm rounded-lg py-2.5 px-3 flex-1 mr-1.5 active:bg-gray-100"
              >
                <span className="font-medium text-base text-gray-700 ">
                  Cancel
                </span>
              </button>
              <button
                type="button"
                onClick={onModalConfirm}
                disabled={isCancelImportLoading}
                className="border border-solid border-error-600 bg-error-600 active:bg-error-700 shadow-sm rounded-lg py-2.5 px-3 flex-1 ml-1.5 disabled:border-primary-200 disabled:bg-primary-200"
              >
                {isCancelImportLoading && (
                  <span
                    className={`-ml-3 mr-1 [&>*]:!inline [&>*]:!ml-2 [&>*]:!mr-0 [&>*]:!w-[16px] [&>*]:!h-[16px] [&>*]:!opacity-70 [&>*]:!bg-transparent [&>*>*]:!stroke-white-100`}
                  >
                    <SpinLoader />
                  </span>
                )}
                <span className="font-medium text-base text-white-100 ">
                  Delete
                </span>
              </button>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default CancelImportModal
